import { Fragment, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import navdots from '../../../Assets/images/navdots.svg';
import CancellationNoteModal from "../SampleRequest/CancellationNoteModal";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import JobDetailsPopup from "../../../Pages/Donor/JobDetailsPopup";
import ChangeAppointmentTime from "../../../Pages/Donor/ChangeAppointmentTime";
import { formatDate, formatTime, formatCurrency } from "../../../Utils/Common";
import TokenService from "../../../Services/Token.service";
function UpcomingDonationsTableRow({ donation, handleChangeAppointmentTime, handleDeleteUpcomingDonation, fetchDonorList, sampleTypes, userType }) {


    const [showJobDetailsAcceptModal, setShowJobDetailsAcceptModal] = useState(false);
    const handleShowJobDetailsAcceptModal = () => setShowJobDetailsAcceptModal(true);
    const handleCloseJobDetailsAcceptModal = () => setShowJobDetailsAcceptModal(false);
    const handleShowChangeAppointmentTimeModal = () => setShowChangeAppointmentTimeModal(true);
    const handleCloseChangeAppointmentTimeModal = () => setShowChangeAppointmentTimeModal(false);
    const userRestrictions = TokenService.getUserRestrictions() || [];
 
    const confirmChangeAppointmentTime = (values) => {
        handleChangeAppointmentTime(values)
        handleCloseChangeAppointmentTimeModal();
    };

    const navigate = useNavigate();
    const handleEditDonor = () => {
        navigate(`donation-details/${donation.id}`);
    };


    const [showChangeAppointmentTimeModal, setShowChangeAppointmentTimeModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = (cancellationNote) => { 
        handleDeleteUpcomingDonation(donation.parent_id, cancellationNote);
        handleCloseDeleteModal();
    };

    const sampleIds = donation.sample_ids ? donation.sample_ids.split(',').map(id => id.trim()) : [];
    return (
        <>
            <tr>
                <td>
                    {formatDate(donation.appointment_date)}
                </td>
                <td>
                    {formatTime(donation.appointment_time)}
                </td>
                <td>
                    {donation.job_id}
                </td>
                <td>
                    {donation.lab_name}
                </td>
                <td className="">
                    <div className="el-icons-bg-box">
                        {sampleIds.length > 0 ? (
                            sampleIds.map((sampleId) => {
                                const sampleType = sampleTypes.find((type) => type.id === sampleId);
                                return sampleType ? (                                   
                                    <Fragment key={sampleId}>
                                        {sampleIds.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                            key={sampleId}
                                            placement="top"
                                            overlay={
                                                <Popover id={`popover-${sampleId}`}>
                                                    <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                                </Popover>
                                            }
                                        >
                                            <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                                <i className={sampleType.className}></i>
                                            </Button>                                            
                                        </OverlayTrigger>
                                        </>)}


                                    </Fragment>
                                ) : null;
                            })
                        ) : (
                            ""
                        )}
                    </div>
                </td>               
                {userType == "donor" && (
                    <>
                        <td><span> {formatCurrency(donation.total_price)}</span></td>
                    </>
                )}
                <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item onClick={handleShowJobDetailsAcceptModal}>
                                    <label>View Job Details</label>
                                </Dropdown.Item>

                                {/* {userType!=="donor" &&(
                                    <Dropdown.Item>
                                        <label>Collect sample</label>
                                    </Dropdown.Item>
                                )} */}
                                {userType !== 'donor'  && (donation.status !== 4 ) &&  (     // no requestor and no status cancelled
                                    <Dropdown.Item   as={Link} to={`/admin/sample-requests/collectsamples`} state={{ sampleType :  donation, type:"admin", id: donation.request_id , isCollectSample : true} } >
                                        <label>Collect Samples</label>
                                    </Dropdown.Item>

                                )}

                                {!userRestrictions.includes('job-board') && (
                                    <>
                                        {userType === "donor" && (
                                            <Dropdown.Item onClick={handleShowChangeAppointmentTimeModal}>
                                                <label>Change Appointment Time</label>
                                            </Dropdown.Item>
                                        )}
                                    </>
                                )}

                                <Dropdown.Item onClick={handleShowDeleteModal}>
                                    <label className="text-danger">Cancel Donation</label>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>

            {showDeleteModal && (                    
                <CancellationNoteModal 
                    show={showDeleteModal}
                    onHide={handleCloseDeleteModal}
                    onConfirm={confirmDeleteUser}
                    title="Cancel Appointment"
                    body="Are you sure you want to cancel this donation?"
                    type="cancel_appointment"
                />
            )}
            
            {showChangeAppointmentTimeModal && (
                <ChangeAppointmentTime
                    appointment_id={donation.parent_id}
                    show={showChangeAppointmentTimeModal}
                    onHide={handleCloseChangeAppointmentTimeModal}
                    onConfirm={confirmChangeAppointmentTime} 
                />
            )}

            {showJobDetailsAcceptModal && (
                <JobDetailsPopup
                    show={showJobDetailsAcceptModal}
                    onHide={handleCloseJobDetailsAcceptModal}
                    donation={donation}
                />
            )}
        </>
    );
}
export default UpcomingDonationsTableRow;